"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _ckeditor4React = _interopRequireDefault(require("ckeditor4-react"));

var _mentions = require("./mentions");

var _oembed = _interopRequireDefault(require("./oembed"));

var _attachments = _interopRequireDefault(require("./attachments"));

var _emoji = _interopRequireDefault(require("./emoji"));

var _quote = _interopRequireDefault(require("./quote"));

var _autocorrect = _interopRequireDefault(require("./autocorrect"));

var _spoiler = _interopRequireDefault(require("./spoiler"));

var _menu = _interopRequireDefault(require("./menu"));

var _customMenuButton = _interopRequireDefault(require("./customMenuButton"));

var _callout = _interopRequireDefault(require("./callout"));

var _imageupload = _interopRequireDefault(require("./imageupload"));

var _poll = _interopRequireDefault(require("./poll"));

var _customPaste = _interopRequireDefault(require("./customPaste"));

var _toolbar = _interopRequireDefault(require("./toolbar"));

var _constants = require("libs/constants");

var _globals = _interopRequireWildcard(require("@insided/shared/utils/globals"));

var _translations = _interopRequireDefault(require("./translations"));

var _translations2 = require("../../libs/translationsUtils/translations");

var _variable = _interopRequireDefault(require("./variable"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emailWidgetsPlugin = _interopRequireDefault(require("./emailWidgetsPlugin"));

var _tableOfContents = _interopRequireDefault(require("./tableOfContents"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _insertExternalHtmlPlugin = _interopRequireDefault(require("./insertExternalHtmlPlugin"));

var _iorad = _interopRequireDefault(require("./iorad"));

var _codeHighlighting = require("@insided/shared/bootstrap/codeHighlighting");

var _iconMap;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

if (typeof __webpack_public_path__ !== 'undefined') {
  window.CKEDITOR_BASEPATH = __webpack_public_path__ + 'ckeditor/';
  _ckeditor4React.default.editorUrl = __webpack_public_path__ + 'ckeditor/ckeditor.js';
}

var iconMap = (_iconMap = {}, (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Forum', 'wysiwyg.b.btn.title'), 'bold'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Forum', 'wysiwyg.i.btn.title'), 'italic'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Forum', 'wysiwyg.u.btn.title'), 'underline'), (0, _defineProperty2.default)(_iconMap, 'Remove Format', 'remove-format'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Forum', 'wysiwyg.ul.btn.title'), 'list'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Forum', 'wysiwyg.ol.btn.title'), 'ordered-list'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Forum', 'wysiwyg.links.btn.title'), 'link'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Forum', 'wysiwyg.image.btn.title'), 'image'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Forum', 'wysiwyg.quote.btn.title'), 'quote'), (0, _defineProperty2.default)(_iconMap, "Iorad", 'iorad'), (0, _defineProperty2.default)(_iconMap, 'Insert Media Embed', 'video'), (0, _defineProperty2.default)(_iconMap, 'Insert Code Snippet', 'code'), (0, _defineProperty2.default)(_iconMap, 'Insert Horizontal Line', 'hr'), (0, _defineProperty2.default)(_iconMap, "Source", 'source'), (0, _defineProperty2.default)(_iconMap, "Spoiler", 'spoiler'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Forum', 'wysiwyg.poll.btn.title'), 'poll'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Forum', 'wysiwyg.emoji.btn.title'), 'emoji'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Forum', 'wysiwyg.links.btn.upload'), 'attach-file'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Common', 'editor.text.color'), 'text-color'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Common', 'editor.background.color'), 'bg-color'), (0, _defineProperty2.default)(_iconMap, "Table", 'table'), (0, _defineProperty2.default)(_iconMap, (0, _translations2.t)('Common', 'editor.toolbar.more'), 'more'), (0, _defineProperty2.default)(_iconMap, 'Insert Attribute', 'variable'), (0, _defineProperty2.default)(_iconMap, 'Align Left', 'format-align-left'), (0, _defineProperty2.default)(_iconMap, "Center", 'format-align-center'), (0, _defineProperty2.default)(_iconMap, 'Align Right', 'format-align-right'), (0, _defineProperty2.default)(_iconMap, 'Table of contents', 'bookmark-anchor'), _iconMap);
/**
 * Overwrites CKEDITOR.ui.button.render method to use our own icons
 */

var patchButtonRender = function patchButtonRender(buttonPrototype) {
  var render = buttonPrototype.render;

  buttonPrototype.render = function (editor, output) {
    var template = render.call(this, editor, output);
    var icon = iconMap[this.label];
    var iconHtml = '';

    if (icon) {
      iconHtml = require('./icons/' + icon + '.svg');
    }

    var rendered = output.pop().replace(/style="[^"]+"/, 'style="background: none !important"').replace('&nbsp;', iconHtml);
    output.push(rendered);
    return template;
  };
};
/**
 * Overwrites CKEDITOR.menuItem.render method to use our own icons
 * in the dropdown
 */


var patchMenuItemRender = function patchMenuItemRender(menuItemPrototype) {
  var render = menuItemPrototype.render;

  menuItemPrototype.render = function (menu, index, output) {
    render.call(this, menu, index, output);
    var icon = iconMap[menu.items[index].iconLabel];
    var iconHtml = '';

    if (icon) {
      iconHtml = require("./icons/".concat(icon, ".svg"));
    }

    var toSearch = "<span class=\"cke_button_icon cke_button__".concat(menu.items[index].icon, "_icon\" style=\"background: none !important\"></span>");
    var toReplace = "<span class=\"cke_button_icon cke_button__".concat(menu.items[index].icon, "_icon\" style=\"background: none !important\">").concat(iconHtml, "</span>");
    var rendered = output.pop().replace(/style="[^"]*"/, 'style="background: none !important"').replace(toSearch, toReplace);
    output.push(rendered);
  };
};

var hideCaptionOnMobile = function hideCaptionOnMobile() {
  var currentEl = document.getElementsByClassName('current')[0];
  if (!currentEl) return;
  var ckIframes = document.getElementsByClassName('cke_wysiwyg_frame');
  if (!ckIframes) return;

  for (var i = 0; i < ckIframes.length; i++) {
    var isMobile = window.innerWidth < 768;
    var doc = ckIframes[i].contentWindow.document;
    var newScript = doc.createElement('style');
    var content = doc.createTextNode("\n      figure figcaption {\n        display: ".concat(isMobile ? 'none !important;' : 'block;', "\n      }\n    "));
    newScript.appendChild(content);
    var bodyClass = doc.getElementsByTagName('head')[0];
    bodyClass.insertBefore(newScript, bodyClass.lastChild);
  }
};

var preventGrammarlyFromInitializing = function preventGrammarlyFromInitializing() {
  var ckIframes = document.getElementsByClassName('cke_wysiwyg_frame');

  for (var i = 0; i < ckIframes.length; i++) {
    var iframeDoc = ckIframes[i].contentWindow.document;
    var body = iframeDoc.getElementsByTagName('body')[0];

    if (body) {
      body.setAttribute('data-gramm', 'false');
    }
  } // Remove Grammarly from editors


  document.querySelectorAll('.html-editor').forEach(function (editor) {
    editor.querySelectorAll('grammarly-extension').forEach(function (el) {
      return el.remove();
    }); // Watch for new additions (self-cleaning - disconnects when iframe is removed)

    var observer = new MutationObserver(function (mutations, obs) {
      // Check if CKEditor iframe still exists - if not, editor was removed, cleanup
      var iframe = editor.querySelector('.cke_wysiwyg_frame');

      if (!iframe || !document.contains(iframe)) {
        obs.disconnect();
        return;
      }

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeName === 'GRAMMARLY-EXTENSION') {
            node.remove();
          }
        });
      });
    });
    observer.observe(editor, {
      childList: true
    });
  });
};

function updateCodeSnippetPreview(previewDiv, codeField) {
  if (!previewDiv) return;
  var raw = (codeField === null || codeField === void 0 ? void 0 : codeField.getValue()) || '';

  var _parseInlineHighlight = (0, _codeHighlighting.parseInlineHighlightMarkers)(raw),
      code = _parseInlineHighlight.cleanedText;

  var container = previewDiv.$ ? previewDiv.$ : previewDiv;

  while (container.firstChild) {
    container.firstChild.remove();
  }

  if (!code.trim()) {
    container.textContent = 'Enter code above to see preview...';
    return;
  }

  var lines = code.split('\n');

  for (var index = 0; index < lines.length; index++) {
    var line = lines[index];
    var lineDiv = document.createElement('div');
    lineDiv.className = 'code-preview-line';
    var numSpan = document.createElement('span');
    numSpan.className = 'code-preview-line-num';
    numSpan.textContent = String(index + 1);
    var contentSpan = document.createElement('span');
    contentSpan.className = 'code-preview-line-content';
    contentSpan.textContent = line;
    lineDiv.appendChild(numSpan);
    lineDiv.appendChild(contentSpan);
    container.appendChild(lineDiv);
  }
}

var editorInFocus; // eslint-disable-next-line import/no-anonymous-default-export

var _default = function _default(_ref) {
  var _classNames;

  var data = _ref.data,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _onInstanceReady = _ref.onInstanceReady,
      _onFileAttachment = _ref.onFileAttachment,
      _onEmojiSelect = _ref.onEmojiSelect,
      _onFocus = _ref.onFocus,
      showNotification = _ref.showNotification,
      isGuest = _ref.isGuest,
      autoFocus = _ref.autoFocus,
      isControl = _ref.isControl,
      canHavePoll = _ref.canHavePoll,
      disableFileAttachments = _ref.disableFileAttachments,
      disableMentions = _ref.disableMentions,
      placeholder = _ref.placeholder,
      profile = _ref.profile,
      onTopicCardClicked = _ref.onTopicCardClicked,
      showEmbedMedia = _ref.showEmbedMedia,
      _ref$callback = _ref.callback,
      callback = _ref$callback === void 0 ? function () {} : _ref$callback;
  var dataFromEditor = data;
  var useCompactAutoGrow = !profile || profile === 'reply' || profile === 'topicEdit';
  var isUploadAllowed = (0, _globals.default)('activeModules').includes('nonModeratorsCanUploadImagesAndVideos') || (0, _globals.default)('application') === 'control';
  var debouncedOnChange = (0, _debounce.default)(function (evt) {
    var data = evt.editor.getData();
    if (dataFromEditor === data) return;
    onChange(data);
    dataFromEditor = data;
  }, 150);
  var communityLanguage = (0, _globals.default)('communityLanguage');
  var removePlugins = ['removeformat', 'resize'];

  if (!isControl) {
    removePlugins.push('sourcearea');
  }

  var device = (0, _insidedDataStorage.getInsidedData)('device');
  var disableTableTools = !isControl && device !== 'desktop';

  if (disableTableTools) {
    removePlugins = removePlugins.concat(['tableselection', 'tabletools', 'tableresize', 'contextmenu']);
  }

  if (!isUploadAllowed) {
    removePlugins.push('embed');
  }

  if (profile !== 'email') {
    removePlugins.push('variable');
    removePlugins.push('email-widgets');
  }

  if (profile !== 'openingPost' && profile !== 'topicEdit') {
    removePlugins.push('table-of-contents');
  }

  var extraPlugins = ['onchange', 'menubutton', 'autocorrect', 'mention-box', 'quote-box', 'iorad', 'insided-emoji', 'spoiler', 'custom-menu', 'callout', 'variable', 'email-widgets', 'poll', 'custom-paste', 'confighelper', 'table-of-contents', 'pastefromgdocs', 'insert-external-html'];

  if (isUploadAllowed) {
    extraPlugins.push('imageupload');

    if (showEmbedMedia) {
      extraPlugins.push('oembed-box');
    } else {
      removePlugins.push('autoembed');
    }

    if (!disableFileAttachments) {
      extraPlugins.push('insided-attachments');
    }
  }

  var codeSnippetLanguages = {
    apache: 'Apache',
    bash: 'Bash',
    c: 'C',
    csharp: 'C#',
    css: 'CSS',
    diff: 'Diff',
    html: 'HTML',
    http: 'HTTP',
    ini: 'INI',
    java: 'Java',
    javascript: 'JavaScript',
    json: 'JSON',
    makefile: 'Makefile',
    markdown: 'Markdown',
    nginx: 'Nginx',
    nqe: 'NQE',
    objectivec: 'Objective-C',
    perl: 'Perl',
    powershell: 'PowerShell',
    php: 'PHP',
    python: 'Python',
    ruby: 'Ruby',
    sql: 'SQL',
    swift: 'Swift',
    vbscript: 'VBScript',
    xhtml: 'XHTML',
    xml: 'XML',
    yara: 'YARA'
  };
  return (0, _preact.h)("div", null, (0, _preact.h)(_ckeditor4React.default, {
    data: data,
    onBeforeLoad: function onBeforeLoad(CKEDITOR) {
      if (CKEDITOR.isEditorConfigured) return;
      CKEDITOR.disableAutoInline = true; // https://github.com/ckeditor/ckeditor4-react/issues/57#issuecomment-520377696
      // disable errors in logs in production

      if (!IS_LOCAL) CKEDITOR.verbosity = 0;
      patchButtonRender(CKEDITOR.ui.button.prototype);
      patchMenuItemRender(CKEDITOR.menuItem.prototype);
      CKEDITOR.isEditorConfigured = true;
      CKEDITOR.lang.languages[communityLanguage] = 1;
      CKEDITOR.lang[communityLanguage] = (0, _translations.default)();
      CKEDITOR.config.keystrokes = [[window.CKEDITOR.SHIFT + window.CKEDITOR.CTRL + 88, 'strike']];
      CKEDITOR.config.contentsCss = [CKEDITOR.getUrl('contents.css'), CKEDITOR.getUrl('insided-contents.css'), (0, _globals.default)('cssLink'), (0, _globals.default)('cssVariables')]; // Override confighelper plugin's getPlaceholderCss to support CSS variables for theming 

      var confighelperPlugin = CKEDITOR.plugins.get('confighelper');

      if (!isControl && confighelperPlugin) {
        confighelperPlugin.getPlaceholderCss = function () {
          return '.placeholder { color: var(--config-main-navigation-search-placeholder-color, #999); }';
        };
      }

      CKEDITOR.plugins.get('cloudservices').beforeInit = function () {
        CKEDITOR.plugins.cloudservices.cloudServicesLoader.prototype.upload = function (_, params) {
          if (this.file && this.file.size > _constants.maxImageFileSize) {
            showNotification('Common', 'js.uploader.error_file_size');
            this.changeStatus('abort');
            return;
          }

          CKEDITOR.fileTools.fileLoader.prototype.upload.call(this, '/attachment/new', params);
        };
      };

      if (navigator.userAgent.includes('Chrome')) {
        CKEDITOR.plugins.get('clipboard').beforeInit = function () {
          CKEDITOR.plugins.clipboard.dataTransfer.prototype.getFilesCount = function () {
            var _this$$, _this$$$files;

            if (this._.files.length && !this._.data.Text) {
              return this._.files.length;
            }

            if ((_this$$ = this.$) !== null && _this$$ !== void 0 && (_this$$$files = _this$$.files) !== null && _this$$$files !== void 0 && _this$$$files.length && !this._.data.Text) {
              return this.$.files.length;
            }

            return this._getImageFromClipboard() ? 1 : 0;
          };
        };
      }

      CKEDITOR.plugins.add('mention-box', _mentions.mentionBoxPlugin);
      CKEDITOR.plugins.add('insided-emoji', _emoji.default);
      CKEDITOR.plugins.add('insided-attachments', _attachments.default);
      CKEDITOR.plugins.add('quote-box', _quote.default);
      CKEDITOR.plugins.add('iorad', _iorad.default);
      CKEDITOR.plugins.add('oembed-box', _oembed.default);
      CKEDITOR.plugins.add('autocorrect', _autocorrect.default);
      CKEDITOR.plugins.add('custom-menu', _menu.default);
      CKEDITOR.plugins.add('menubutton', _customMenuButton.default);
      CKEDITOR.plugins.add('spoiler', _spoiler.default);
      CKEDITOR.plugins.add('poll', _poll.default);
      CKEDITOR.plugins.add('callout', _callout.default);
      CKEDITOR.plugins.add('imageupload', _imageupload.default);
      CKEDITOR.plugins.add('custom-paste', _customPaste.default);
      CKEDITOR.plugins.add('variable', _variable.default);
      CKEDITOR.plugins.add('email-widgets', _emailWidgetsPlugin.default);
      CKEDITOR.plugins.add('table-of-contents', _tableOfContents.default);
      CKEDITOR.plugins.add('insert-external-html', _insertExternalHtmlPlugin.default);
      CKEDITOR.on('dialogDefinition', function (evt) {
        var dialogName = evt.data.name;
        var dialogDefinition = evt.data.definition;
        dialogDefinition.resizable = CKEDITOR.DIALOG_RESIZE_NONE;
        dialogDefinition.buttons = [CKEDITOR.dialog.okButton.override({
          align: 'left'
        }), CKEDITOR.dialog.cancelButton.override({
          align: 'left'
        })];

        if (dialogName === 'link') {
          dialogDefinition.minHeight = 140;
          var infoTab = dialogDefinition.getContents('info');
          infoTab.get('linkType').className = 'is-hidden';
          infoTab.get('urlOptions').className = 'js-ckeditor-link-url-options';
        }

        if (dialogName === 'table') {
          var info = dialogDefinition.getContents('info');
          info.remove('txtBorder');
          info.remove('cmbAlign');
          info.remove('txtWidth');
          info.remove('txtHeight');
          info.remove('txtCellSpace');
          info.remove('txtCellPad');
          info.remove('txtCaption');
          info.remove('txtSummary');
        }

        if (dialogName === 'codeSnippet') {
          var _dialogDefinition$con;

          var _infoTab = dialogDefinition.getContents ? dialogDefinition.getContents('info') : (_dialogDefinition$con = dialogDefinition.contents) === null || _dialogDefinition$con === void 0 ? void 0 : _dialogDefinition$con[0];

          if (!_infoTab) return;

          _infoTab.elements.push({
            type: 'html',
            id: 'preview',
            html: '<div style="margin-top:10px"><strong>Preview:</strong>' + '<div id="code-preview">Enter code above to see preview...</div></div>'
          });

          var originalOnShow = dialogDefinition.onShow;

          dialogDefinition.onShow = function () {
            if (typeof originalOnShow === 'function') originalOnShow.apply(this, arguments);
            var langField = this.getContentElement('info', 'lang');
            var codeField = this.getContentElement('info', 'code');
            var previewHtmlEl = this.getContentElement('info', 'preview');
            var previewDiv = previewHtmlEl === null || previewHtmlEl === void 0 ? void 0 : previewHtmlEl.getElement().findOne('#code-preview');
            var boundUpdate = updateCodeSnippetPreview.bind(null, previewDiv, codeField);

            if (codeField) {
              var _codeField$getInputEl;

              codeField.on('change', boundUpdate);
              var inputEl = (_codeField$getInputEl = codeField.getInputElement) === null || _codeField$getInputEl === void 0 ? void 0 : _codeField$getInputEl.call(codeField);
              if (inputEl) inputEl.on('keyup', boundUpdate);
            }

            if (langField) langField.on('change', boundUpdate);
            boundUpdate();
          };

          var originalOnOk = dialogDefinition.onOk;

          dialogDefinition.onOk = function () {
            return originalOnOk === null || originalOnOk === void 0 ? void 0 : originalOnOk.apply(this, arguments);
          };
        }
      });
      CKEDITOR.on('instanceReady', function () {
        hideCaptionOnMobile();
        preventGrammarlyFromInitializing();
      });
    },
    onInstanceReady: function onInstanceReady(evt) {
      var editor = evt.editor;

      _onInstanceReady(editor);

      var currentEditor = Symbol(Math.random() + '');
      editorInFocus = currentEditor;
      editor.on('focus', function () {
        editorInFocus = currentEditor;
      });
      editor.editable().on('input', function () {
        debouncedOnChange(evt);
      });
      (0, _globals.subscribe)('quote', function (payload) {
        if (editorInFocus === currentEditor) {
          editor.execCommand('quote-user', {
            user: payload.username,
            data: payload.content
          });
        }
      });
      (0, _globals.subscribe)('mention', function (payload) {
        if (editorInFocus === currentEditor) {
          editor.execCommand('mention', {
            username: payload.username,
            id: payload.id
          });
        }
      });
      (0, _globals.subscribe)('ai_submitted', function (payload) {
        if (editorInFocus === currentEditor) {
          editor.execCommand('insert-external-html', {
            html: payload.html
          });
        }
      });
      callback();

      if (editor.addMenuItems) {
        editor.on('menuShow', function () {
          var path = editor.elementPath();

          if (path !== null && path !== void 0 && path.contains({
            td: 1,
            th: 1
          })) {
            // Removes 'table properties' from table's context menu only
            editor.removeMenuItem('table');
            editor.removeMenuItem('tablecell_properties'); // Removes cut/copy/paste options for tables only

            editor.removeMenuItem('copy');
            editor.removeMenuItem('paste');
            editor.removeMenuItem('cut');
          }
        });
      } // disable context menu outside tables and code blocks


      editor.editable().on('contextmenu', function (evt) {
        var _path$elements;

        var path = editor.elementPath(); // Allow context menu for tables

        if (path !== null && path !== void 0 && path.contains({
          td: 1,
          th: 1
        })) {
          return;
        } // Allow context menu for code blocks


        if (path !== null && path !== void 0 && path.contains('div', 1) && (_path$elements = path.elements) !== null && _path$elements !== void 0 && _path$elements.some(function (el) {
          var _el$hasClass;

          return el === null || el === void 0 ? void 0 : (_el$hasClass = el.hasClass) === null || _el$hasClass === void 0 ? void 0 : _el$hasClass.call(el, 'cke_widget_codeSnippet');
        })) {
          return;
        }

        evt.cancel();
      }, undefined, undefined, 1);
      editor.on('doubleclick', function (evt) {
        var element = evt.data.element;

        if (element.is('table')) {
          evt.data.dialog = '';
        }
      }); // fix exiting from the link on firefox when you press space

      if (window.navigator.userAgent.match('Firefox')) {
        editor.on('key', function (evt) {
          if (evt.data.keyCode !== 32) return;
          var linkElement = window.CKEDITOR.plugins.link.getSelectedLink(editor);
          if (!(linkElement !== null && linkElement !== void 0 && linkElement.is('a'))) return;
          var range = editor.getSelection().getRanges()[0];
          if (!range.checkBoundaryOfElement(linkElement)) return;
          var newRange = editor.createRange();
          newRange.moveToPosition(linkElement, window.CKEDITOR.POSITION_AFTER_END);
          editor.getSelection().selectRanges([newRange]);
        });
      }
    },
    onFileAttachment: function onFileAttachment(files) {
      _onFileAttachment(files);
    },
    onKey: function onKey() {
      return _onFocus();
    },
    onFocus: function onFocus(evt) {
      var _evt$editor, _evt$editor$element, _evt$editor$element$$;

      if (isGuest) {
        var event = new window.CustomEvent('GuestUserAction');
        return window.dispatchEvent(event);
      }

      _onFocus();

      evt === null || evt === void 0 ? void 0 : (_evt$editor = evt.editor) === null || _evt$editor === void 0 ? void 0 : (_evt$editor$element = _evt$editor.element) === null || _evt$editor$element === void 0 ? void 0 : (_evt$editor$element$$ = _evt$editor$element.$) === null || _evt$editor$element$$ === void 0 ? void 0 : _evt$editor$element$$.click();
    },
    onEmojiSelect: function onEmojiSelect(files) {
      _onEmojiSelect(files);
    },
    onTopicCardClicked: onTopicCardClicked,
    onNotificationShow: function onNotificationShow(evt) {
      if (evt.data.notification.shouldShow) {
        showNotification(evt.data.notification.category, evt.data.notification.phrase);
      }

      evt.cancel();
    },
    onChange: debouncedOnChange,
    config: _objectSpread(_objectSpread(_objectSpread({
      environment: isControl ? _constants.env.CONTROL : _constants.env.DESTINATION,
      bodyClass: (0, _classnames.default)('post__content--new-editor', 'post__content', (_classNames = {}, (0, _defineProperty2.default)(_classNames, "post__content--".concat(profile), Boolean(profile)), (0, _defineProperty2.default)(_classNames, "cke_editable_is_control", isControl), _classNames)),
      startupFocus: autoFocus,
      placeholder: placeholder && (isControl ? placeholder : (0, _translations2.t)('Forum', placeholder)),
      language: communityLanguage,
      canHavePoll: canHavePoll,
      showEmbedMedia: showEmbedMedia,
      toolbar: (0, _toolbar.default)(profile, isControl ? _constants.env.CONTROL : _constants.env.DESTINATION),
      // removeButtons: 'Strike',
      profile: profile,
      embed_provider: profile !== 'email' ? '/oembed/getembeddedUrl?url={url}&callback={callback}' : undefined,
      uiColor: '#ffffff',
      easyimage_styles: {
        full: {
          attributes: {
            class: 'full-width-figure'
          }
        }
      },
      easyimage_class: null,
      autoGrow_onStartup: true,
      autoGrow_maxHeight: useCompactAutoGrow ? 200 : 10000
    }, useCompactAutoGrow && {
      autoGrow_minHeight: 20
    }), useCompactAutoGrow && {
      height: 20
    }), {}, {
      extraPlugins: extraPlugins.join(','),
      extraAllowedContent: "a[rel,!href];img[height];img[class];user-mention[data-id];h1[id];h2[id];h3[id];h4[id];h5[id];h6[id];oembed[url];content-quote[data-username];content-quote[class];content-spoiler;div(*);section(*);svg[*];ol{list-style-type}[start];code[data-highlight-lines,class];".concat(profile === 'email' ? 'input-variable[type];topic-card;table;th;td;tr;span;style;sub;sup;thead;th;tfoot;*(*);*[*];*{*};' : ''),
      removePlugins: removePlugins.join(','),
      disableNativeSpellChecker: false,
      enterMode: 1,
      removeDialogTabs: 'image:advanced;link:target;link:advanced;',
      mentions: disableMentions ? undefined : _mentions.mentionOptions.feeds,
      codeSnippet_theme: 'github',
      codeSnippet_languages: codeSnippetLanguages,
      magicline_color: '#1b8cbd',
      stylesSet: [// Block-level styles
      {
        name: (0, _translations2.t)('Common', 'editor.paragraph'),
        element: 'p'
      }, {
        name: (0, _translations2.t)('Forum', 'wysiwyg.h1.btn.title'),
        element: 'h2'
      }, {
        name: (0, _translations2.t)('Forum', 'wysiwyg.h3.btn.title'),
        element: 'h3'
      }, // Inline styles
      {
        name: (0, _translations2.t)('Forum', 'wysiwyg.code.btn.title'),
        element: 'code'
      }, // Screen reader only
      {
        name: 'Screen Reader Only',
        element: 'p',
        attributes: {
          class: 'sr-only'
        }
      }]
    })
  }));
};

exports.default = _default;